// コンバートモーダル
import Vue from 'vue'
const ConvertSummary = {
  namespaced: true,

  state: {
    shopId: null,
    shopName: '',
    summary: [],
    selectSummary: {}, // サマリー選択リスト
    selectSummaryText: {}, // サマリー検索テキスト
    result: [],
  },
  getters: {
    getShopId: state => {
      return state.shopId
    },
    getShopName: state => {
      return state.shopName
    },
    getSummary: state => {
      return state.summary
    },
    getSelectSummary: state => {
      return state.selectSummary
    },
    getSelectSummaryText: state => {
      return state.selectSummaryText
    },
    getResult: state => {
      return state.result
    },
  },
  mutations: {
    setShopId(state, shopId) {
      state.shopId = shopId
    },
    setShopName(state, shopName) {
      state.shopName = shopName
    },
    setSummary(state, summary) {
      state.summary = summary
    },
    setSelectSummary(state, selectSummary) {
      state.selectSummary = selectSummary
    },
    setSelectSummaryText(state, selectSummaryText) {
      state.selectSummaryText = selectSummaryText
    },
    setResult(state, result) {
      state.result = result
    },
    changeSelectSummary(state, obj) {
      Vue.set(state.selectSummary, obj.key, obj.value)
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setShopId', item.shop_id)
      commit('setShopName', item.shop_name)
      commit('setSummary', item.summary)
    },
    resetSelectSummary({ commit, state }) {
      _.forEach(state.selectSummary, function(val, key) {
        commit('changeSelectSummary', {
          key: key,
          value: 0,
        })
      })
    },
  },
}

export default ConvertSummary
